import { MastersState } from './interface';

export const initialState: MastersState = {
  measuresTypes: {
    data: [],
    status: null,
  },
  measuresUnits: {
    data: [],
    status: null,
  },
  measuresGenericTypes: {
    data: [],
    status: null,
  },
  measuresStatus: {
    data: [],
    status: null,
  },
  peripheralsTypes: {
    data: [],
    status: null,
  },
  peripherals: {
    data: [],
    status: null,
  },
  peripheralsMeasureTypes: {
    data: [],
    status: null,
  },
  devicesTypes: {
    data: [],
    status: null,
  },
  racesTypes: {
    data: [],
    status: null,
  },
  sexesTypes: {
    data: [],
    status: null,
  },
  agendaTypes: {
    data: [],
    status: null,
  },
  resolutions: {
    archived: {
      data: [],
      total: null,
    },
    notArchived: {
      data: [],
      total: null,
    },
    status: null,
  },
  pathologiesTypes: {
    data: [],
    status: null,
  },
  maritalStatus: {
    data: [],
    status: null,
  },
  language: {
    data: [],
    status: null,
  },
  education: {
    data: [],
    status: null,
  },
  ethnicity: {
    data: [],
    status: null,
  },
  weightBaseline: {
    data: null,
    status: null,
  },
  healthCenter: {
    data: null,
    status: null,
  },
  relationships: {
    data: [],
    status: null,
  },
  serviceType: {
    data: [],
    status: null,
  },
  serviceTypeReason: {
    data: [],
    status: null,
  },
  settingsLanguages: {
    data: [],
    status: null,
  },
  settingsMeasurementUnits: {
    data: [],
    status: null,
  },
  settingsDateFormat: {
    data: [],
    status: null,
  },
  serviceStates: {
    data: [],
    status: null,
  },
};
